export const enum WidgetDisposal {
  /**
   * Disposizione libera. Possono essere più di uno e possono essere
   * ordinati liberamente.
   */
  Free = 'Free',
  /**
   * Fisso in fondo alla pagina di compilazione. Varrebbe comunque
   * anche in caso di Form multi-step, ad esempio il Captcha.
   */
  Fixed = 'Fixed',
  /**
   * In uno step dedicato
   */
  Step = 'Step'
}

/**
 * Disposal ordinati per priorità. Questo serve per l'assegnazione degli indici
 * (`index`) durante la fase di riordinamento.
 */
export const WidgetDisposalPriority = [
  WidgetDisposal.Free,
  WidgetDisposal.Fixed,
  WidgetDisposal.Step
];
